import React, { useEffect, useState } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Wel from "../Components/Wel";
import {
  CreateOrder,
  InventoryBilling,
  TCSApplicability,
  ViewOrder,
} from "../Pages/InstiBilling";
import DNC_Registry_Update from "../Pages/DNC_Registry/DNC_Registry_Update";
import TripCosting from "../Pages/FMS_PO/TripCosting/TripCosting";
import UploadInvoice from "../Pages/FMS_PO/UploadInvoice/UploadInvoice";
import NSO from "../Pages/NSO/Sidebar";
import { Dashboard, Gallery, Planogram } from "../Screens";
import { PlanoTokenAuth } from "../Common";
import ISP_Status from "../Pages/ISP/ISP_Status";
import ISP_Update from "../Pages/ISP/ISP_Update";
import Cookies from "js-cookie";
import ViewInvoice from "../Pages/Non-Merchandise/ViewInvoice/ViewInvoice";
import PrintAssetQr from "../Pages/PrintAssetQR";
import GMB from "../Pages/GMB/Sidebar";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import ForceTrackerTracking from "../Pages/Force_Tracker/Track_Requests/Track_Request";
import ForceTrackerCreation from "../Pages/Force_Tracker/Create_Requests/Create_Request";
import AssetMaster from "../Pages/Asset_GRN/AssetMaster";
import Scope from "../Pages/GMB/Scope";
import EmployeePayments from "../Pages/Vendor_Payments/EmployePayments";
import OCPScreen from "../Pages/OCP/Index";
import ScrapSale from "../Pages/Scrap_Sale/Index";
import EmployeeHistory from "../Pages/Vendor_Payments/EmployeHistory";
import HsbcEmployeePayments from "../Pages/Hsbc/EmployePayments";
import HsbcEmployeeHistory from "../Pages/Hsbc/EmployeHistory";
import CreateTransferReqest from "../Pages/Asset_Transfer/CreateTransferReqest";
import Approve_Transfer from "../Pages/Asset_GRN/Approve_Transfer";
import View_Transfer from "../Pages/Asset_GRN/View_Transfer";
import { useSelector } from "react-redux";
import MaintenanceWrapper from "../CommonComponents/MainTenanceScreen/MaintenanceWrapper";
import MovedToFinance from "../CommonComponents/MovedToFinance/MovedToFinance";
import CabinBooking from "../Pages/Cabin_Booking/Index";
import CabinBookingList from "../Pages/Cabin_Booking/Booking_list";
import CabinBookingList4B from "../Pages/Cabin_Booking/Booking_List_4B";
import CabinBookingList4C from "../Pages/Cabin_Booking/Booking_List_4C";
import CabinBookingList4D from "../Pages/Cabin_Booking/Booking_List_4D";
import CabinBookingList4E from "../Pages/Cabin_Booking/Booking_List_4E";
import CabinBookingList8A from "../Pages/Cabin_Booking/Booking_List_8A";
import CabinBookingList8B from "../Pages/Cabin_Booking/Booking_List_8B";
import CabinBookingList3A from "../Pages/Cabin_Booking/Booking_List_3A";
import CCTV from "../Pages/CCTV/Index";
import CCTVDownload from "../Pages/CCTV/Download";
import AmzCapacity from "../Pages/AmzCapacity/Index";
import AmzBulkUpload from "../Pages/AmzCapacity/Bulkupload";
import DSPosOnOff from "../Pages/DSPosOnOff/DSPosOnOff";
import DeleteMrp from "../Pages/DeleteMrp/Index";
import CCTVRewatch from "../Pages/CCTV/Rewatch";
import AddFace from "../Pages/AttendanceLogs/Index";
import AssetTagging from "../Pages/Asset Tagging/AssetTagging";
import QrControl from "../Pages/QrControl";
import VisiAssetUpload from "../Pages/VisiAssetUpload/index";
import DSRefund from "../Pages/DSRefund/DSRefund";
import MrpManagement from "../Pages/Mrp_Pricing/Mrp_Management";
import PricingManagement from "../Pages/PricingManagement/index";
import TruIDMaster from "../Pages/TruIDMaster";
import DSReport from "../Pages/DSReports";
import ApproveProvisions from "../Pages/Provisioning/ApproveProvisions";
import OverrideProvisions from "../Pages/Provisioning/OverrideProvisions";
import CreateProvisions from "../Pages/Provisioning/CreatingProvisions";
import PricingApproval from "../Pages/PricingApproval/index";
import PoToReopen from "../Screens/PoToReopen";
import Offers from "../Pages/LadderPricing/Index";


const PlanoPrivateRoute = ({ children, loc, storeGal }) => {
  if (loc.length === 4) {
    return <Navigate to="/plano_portal/store" replace />;
  }
  return children;
};
const MainRoutes = () => {
  const [id, setId] = useState(localStorage.getItem("user_id") || "");
  const [token, setToken] = useState(localStorage.getItem("url_token") || "");
  const [username, setUsername] = useState(
    localStorage.getItem("username") || ""
  );
  const [roleid, setRoleId] = useState(localStorage.getItem("role_id") || "");
  const location = useLocation();
  const locCheck = Cookies.get("ssp_loc") || "";

  const dmSansTheme = createTheme({
    typography: {
      fontFamily: "DM Sans, sans-serif",
    },
  });

  useEffect(() => {
    const updateLocalStorageValues = () => {
      setId(localStorage.getItem("user_id") || "");
      setToken(localStorage.getItem("url_token") || "");
      setUsername(localStorage.getItem("username") || "");
      setRoleId(localStorage.getItem("role_id") || "");
    };

    // Update values when the component mounts
    updateLocalStorageValues();

    // Listen to storage events to update values when localStorage changes
    window.addEventListener("storage", updateLocalStorageValues);

    // Clean up the event listener
    return () => {
      window.removeEventListener("storage", updateLocalStorageValues);
    };
  }, []);

  useEffect(() => {
    setId(localStorage.getItem("user_id") || "");
    setToken(localStorage.getItem("url_token") || "");
    setUsername(localStorage.getItem("username") || "");
    setRoleId(localStorage.getItem("role_id") || "");
  }, [location]);

  return (
    <Routes>
      {/* Home */}
      <Route path="/" element={<Wel />} />

      {/* Insti Billing  */}
      {/* <Route path="/order/create" element={<CreateOrder />} />
      <Route path="/order/filter" element={<ViewOrder />} />
      <Route path="/tcs_applicability" element={<TCSApplicability />} /> */}
      <Route
        path="/inventory_billing"
        element={
          <MaintenanceWrapper moduleName="Inventory Billing">
            <InventoryBilling />
          </MaintenanceWrapper>
        }
      />

      {/* DNC */}
      <Route
        path="/dnc_update"
        element={
          <MaintenanceWrapper moduleName="DNC Update">
            <DNC_Registry_Update id={username} token={token} />
          </MaintenanceWrapper>
        }
      />

      {/* ISP */}
      <Route
        path="/isp_update"
        element={
          <MaintenanceWrapper moduleName="ISP Update">
            <ISP_Update id={username} token={token} />
          </MaintenanceWrapper>
        }
      />

      <Route
        path="/isp_status"
        element={
          <MaintenanceWrapper moduleName="ISP Status">
            <ISP_Status id={username} token={token} />
          </MaintenanceWrapper>
        }
      />

      {/* FMS */}
      <Route
        path="/trip_costing"
        element={
          <MaintenanceWrapper moduleName="Trip Costing">
            <TripCosting />
          </MaintenanceWrapper>
        }
      />
      <Route
        path="/upload_invoice"
        element={
          <MaintenanceWrapper moduleName="Upload Invoice">
            <UploadInvoice />
          </MaintenanceWrapper>
        }
      />

      {/* Service GRN */}
      <Route
        path="/service_grn"
        element={<MovedToFinance screen="Service GRN" target="Non-merch Bills > New bill (Against a PO)" path="non-merch-bills?tab=new" />}
      />
      <Route
        path="/view_service_grn"
        element={
          <MaintenanceWrapper moduleName="View Invoice">
            <ViewInvoice />
          </MaintenanceWrapper>
        }
      />

      <Route
        path="/po_creation"
        element={<MovedToFinance screen="PO Creation" target="Non-merch PO > New request" path="non-merch-po?tab=new" />}
      />
      <Route
        path="/po_approval"
        element={<MovedToFinance screen="PO Approval" target="Non-merch PO > Approvals" path="non-merch-po?tab=approvals" />}
      />

      {/* plano */}
      <Route
        path="/plano_portal/store"
        element={
          <MaintenanceWrapper moduleName="Plano Dashboard">
            <Dashboard />
          </MaintenanceWrapper>
        }
      />
      <Route
        path="/plano_portal/plano"
        element={
          <MaintenanceWrapper moduleName="Planogram">
            <Planogram />
          </MaintenanceWrapper>
        }
      />
      <Route
        path="/track_request"
        element={
          <MaintenanceWrapper moduleName="Track Request">
            <ForceTrackerTracking />
          </MaintenanceWrapper>
        }
      />
      <Route
        path="/create_request"
        element={
          <MaintenanceWrapper moduleName="Create Request">
            <ForceTrackerCreation />
          </MaintenanceWrapper>
        }
      />
      <Route
        path="/create_branch"
        element={<MovedToFinance screen="Bank branch creation" target="Masters > Supplier" path="masters/supplier" />}
      />
      <Route
        path="/scrap_sale"
        element={
          <MaintenanceWrapper moduleName="Scrap Sale">
            <ScrapSale />
          </MaintenanceWrapper>
        }
      />
      <Route
        path="/plano_portal/gallery"
        element={
          <MaintenanceWrapper moduleName="Gallery">
            <PlanoPrivateRoute loc={locCheck} storeGal="gallery">
              <Gallery />
            </PlanoPrivateRoute>
          </MaintenanceWrapper>
        }
      />

      {/* NSO */}
      <Route
        path="/nso"
        element={
          <MaintenanceWrapper moduleName="NSO">
            <NSO />
          </MaintenanceWrapper>
        }
      />
      <Route
        path="/print_asset_qr"
        element={
          <MaintenanceWrapper moduleName="Print Asset QR">
            <PrintAssetQr />
          </MaintenanceWrapper>
        }
      />

      {/* GMB */}
      <Route
        path="/gmb"
        element={
          <ThemeProvider theme={dmSansTheme}>
            <Scope>
              <GMB />
            </Scope>
          </ThemeProvider>
        }
      >
        <Route
          path=":gmbStoreCode"
          element={
            <ThemeProvider theme={dmSansTheme}>
              <Scope>
                <GMB />
              </Scope>
            </ThemeProvider>
          }
        />
      </Route>
      <Route
        path="/approve_invoice"
        element={<MovedToFinance screen="Approve Invoice" target="Non-merch Bills > Finance queue" path="non-merch-bills?tab=queue" />}
      />
      <Route
        path="/edit_grn"
        element={<MovedToFinance screen="Edit GRN" target="Non-merch Bills > My bills" path="non-merch-bills?tab=mine" />}
      />
      <Route
        path="/payment_uploads"
        element={<MovedToFinance screen="Vendor payments (Kotak)" target="Payables > Add payment" path="payables" />}
      />
      <Route
        path="/payment_history"
        element={<MovedToFinance screen="Vendor payment history" target="Reports > Payment status" path="reports/payment-status" />}
      />
      <Route
        path="/asset_master"
        element={
          <MaintenanceWrapper moduleName="Asset Master">
            <AssetMaster />
          </MaintenanceWrapper>
        }
      />
      <Route
        path="/payment_verify"
        element={<MovedToFinance screen="Vendor payment verification" target="Approvals" path="approvals" />}
      />
      <Route
        path="/payment_approve"
        element={<MovedToFinance screen="Vendor payment approval" target="Approvals" path="approvals" />}
      />
      <Route
        path="/employee_payments"
        element={
          <MaintenanceWrapper moduleName="Employee Payments">
            <EmployeePayments />
          </MaintenanceWrapper>
        }
      />
      <Route
        path="/employee_history"
        element={
          <MaintenanceWrapper moduleName="Employee History">
            <EmployeeHistory />
          </MaintenanceWrapper>
        }
      />
      <Route
        path="/hsbc_payment_uploads"
        element={<MovedToFinance screen="HSBC vendor payments" target="Payables > Add payment" path="payables" />}
      />
      <Route
        path="/hsbc_payment_history"
        element={<MovedToFinance screen="HSBC payment history" target="Reports > Payment status" path="reports/payment-status" />}
      />
      <Route
        path="/hsbc_payment_verify"
        element={<MovedToFinance screen="HSBC payment verification" target="Approvals" path="approvals" />}
      />
      <Route
        path="/hsbc_payment_approve"
        element={<MovedToFinance screen="HSBC payment approval" target="Approvals" path="approvals" />}
      />
      <Route
        path="/hsbc_employee_payments"
        element={
          <MaintenanceWrapper moduleName="HSBC Employee Payments">
            <HsbcEmployeePayments />
          </MaintenanceWrapper>
        }
      />
      <Route
        path="/hsbc_employee_history"
        element={
          <MaintenanceWrapper moduleName="HSBC Employee History">
            <HsbcEmployeeHistory />
          </MaintenanceWrapper>
        }
      />

      {/* OCP SCREENS */}
      <Route
        path="/ocp_prices"
        element={
          <MaintenanceWrapper moduleName="OCP Prices">
            <OCPScreen />
          </MaintenanceWrapper>
        }
      />

      <Route
        path="/create_transfer_request"
        element={
          <MaintenanceWrapper moduleName="Create Transfer Request">
            <CreateTransferReqest />
          </MaintenanceWrapper>
        }
      />
      <Route
        path="/view_transfer"
        element={
          <MaintenanceWrapper moduleName="View Transfer">
            <View_Transfer />
          </MaintenanceWrapper>
        }
      />
      <Route
        path="/approve_transfer"
        element={
          <MaintenanceWrapper moduleName="Approve Transfer">
            <Approve_Transfer />
          </MaintenanceWrapper>
        }
      />
      <Route
        path="/slotify_booking"
        element={
          <MaintenanceWrapper moduleName="Cabin Booking">
            <CabinBooking />
          </MaintenanceWrapper>
        }
      />
      <Route
        path="/slotify_list/corellia"
        element={
          <MaintenanceWrapper moduleName="Cabin Booking">
            <CabinBookingList />
          </MaintenanceWrapper>
        }
      />
      <Route
        path="/slotify_list/naboo"
        element={
          <MaintenanceWrapper moduleName="Cabin Booking">
            <CabinBookingList4B />
          </MaintenanceWrapper>
        }
      />
      <Route
        path="/slotify_list/alderaan"
        element={
          <MaintenanceWrapper moduleName="Cabin Booking">
            <CabinBookingList4C />
          </MaintenanceWrapper>
        }
      />
      <Route
        path="/slotify_list/kashyyyk"
        element={
          <MaintenanceWrapper moduleName="Cabin Booking">
            <CabinBookingList4D />
          </MaintenanceWrapper>
        }
      />
      <Route
        path="/slotify_list/bespin"
        element={
          <MaintenanceWrapper moduleName="Cabin Booking">
            <CabinBookingList4E />
          </MaintenanceWrapper>
        }
      />
      <Route
        path="/slotify_list/coruscant"
        element={
          <MaintenanceWrapper moduleName="Cabin Booking">
            <CabinBookingList8A />
          </MaintenanceWrapper>
        }
      />
      <Route
        path="/slotify_list/tatooine"
        element={
          <MaintenanceWrapper moduleName="Cabin Booking">
            <CabinBookingList8B />
          </MaintenanceWrapper>
        }
      />
      <Route
        path="/slotify_list/endor"
        element={
          <MaintenanceWrapper moduleName="Cabin Booking">
            <CabinBookingList3A />
          </MaintenanceWrapper>
        }
      />
      <Route
        path="/cctv"
        element={
          <MaintenanceWrapper moduleName="cctv">
            <CCTV />
          </MaintenanceWrapper>
        }
      />

      <Route
        path="/cctv_download"
        element={
          <MaintenanceWrapper moduleName="cctv">
            <CCTVDownload />
          </MaintenanceWrapper>
        }
      />

      <Route
        path="/cctv_playback"
        element={
          <MaintenanceWrapper moduleName="cctv">
            <CCTVRewatch />
          </MaintenanceWrapper>
        }
      />

      <Route
        path="/darksaber/dsPosOnOff"
        element={
          <MaintenanceWrapper moduleName="POS Manager">
            <DSPosOnOff />
          </MaintenanceWrapper>
        }
      />

      <Route
        path="/capacity"
        element={
          <MaintenanceWrapper moduleName="Amz Capacity">
            <AmzCapacity />
          </MaintenanceWrapper>
        }
      />

      <Route
        path="/upload"
        element={
          <MaintenanceWrapper moduleName="Amz Capacity">
            <AmzBulkUpload />
          </MaintenanceWrapper>
        }
      />

      <Route
        path="/deletemrp"
        element={
          <MaintenanceWrapper moduleName="Delete Mrp">
            <DeleteMrp />
          </MaintenanceWrapper>
        }
      />

      <Route
        path="/add_bio_face"
        element={
          <MaintenanceWrapper moduleName="Add Face">
            <AddFace />
          </MaintenanceWrapper>
        }
      />

      <Route
        path="/asset_tagging"
        element={
          <MaintenanceWrapper moduleName="Asset Tagging">
            <AssetTagging />
          </MaintenanceWrapper>
        }
      />
      <Route
        path="/qr_control"
        element={
          <MaintenanceWrapper moduleName="Qr Control">
            <QrControl />
          </MaintenanceWrapper>
        }
      />

      <Route
        path="/visi_asset_upload"
        element={
          <MaintenanceWrapper moduleName="Visi Asset Upload">
            <VisiAssetUpload />
          </MaintenanceWrapper>
        }
      />
      <Route
        path="/darksaber/dsRefund"
        element={
          <MaintenanceWrapper moduleName="DS Refund">
            <DSRefund />
          </MaintenanceWrapper>
        }
      />
      <Route
        path="/TruID_master"
        element={
          <MaintenanceWrapper moduleName="TruID master">
            <TruIDMaster />
          </MaintenanceWrapper>
        }
      />
      <Route
        path="/mrp_management"
        element={
          <MaintenanceWrapper moduleName="MRP Pricing">
            <MrpManagement />
          </MaintenanceWrapper>
        }
      />
      <Route
        path="/pricing_management"
        element={
          <MaintenanceWrapper moduleName="Pricing Management">
            <PricingManagement />
          </MaintenanceWrapper>
        }
      />
      <Route
        path="/ds_reports"
        element={
          <MaintenanceWrapper moduleName="ds reports">
            <DSReport />
          </MaintenanceWrapper>
        }
      />
      <Route
        path="/invoice_upload"
        element={<MovedToFinance screen="Invoice Upload" target="Non-merch Bills > New bill (Without a PO)" path="non-merch-bills?tab=new" />}
      />
      <Route
        path="/debit_note"
        element={<MovedToFinance screen="Debit notes" target="Debit / Credit Notes" path="debit-credit-notes" />}
      />
      <Route
        path="/create_provisions"
        element={
          <MaintenanceWrapper moduleName="Create Provisions">
            <CreateProvisions />
          </MaintenanceWrapper>
        }
      />
      <Route
        path="/approve_provisions"
        element={
          <MaintenanceWrapper moduleName="Approve Provisions">
            <ApproveProvisions />
          </MaintenanceWrapper>
        }
      />

      <Route
        path="/override_provisions"
        element={
          <MaintenanceWrapper moduleName="Override Provisions">
            <OverrideProvisions />
          </MaintenanceWrapper>
        }
      />
      <Route
        path="/pricing-approval"
        element={
          <MaintenanceWrapper moduleName="Pricing Approval">
            <PricingApproval />
          </MaintenanceWrapper>
        }
      />
      <Route
        path="/po_to_reopen"
        element={
          <MaintenanceWrapper moduleName="PoToReopen">
            <PoToReopen />
          </MaintenanceWrapper>
        }
      />
      <Route
        path="/offers"
        element={
          <MaintenanceWrapper moduleName="Offers">
            <Offers />
          </MaintenanceWrapper>
        }
      />

      <Route
        path="/jv_management"
        element={<MovedToFinance screen="Journal vouchers" target="Journal Vouchers" path="journal-vouchers" />}
      />
      <Route
        path="/jv_approvals"
        element={<MovedToFinance screen="JV approvals" target="Journal Vouchers" path="journal-vouchers" />}
      />
      <Route
        path="/receipt"
        element={<MovedToFinance screen="Customer receipts" target="Receivables" path="receivables" />}
      />
    </Routes>
  );
};

export default MainRoutes;
